module.exports = __webpack_public_path__ + "static/media/icon_outlook.a31838d2.svg";